import { ApiResponse, getAxiosClient, makeApiRequest } from '@givelify/utils';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

export class ApiRequest {
    public static get<T>(
        url: string,
        config?: AxiosRequestConfig,
        client: AxiosInstance = getAxiosClient(),
    ): Promise<ApiResponse<T>> {
        return makeApiRequest<T>(client.get(url, config));
    }

    public static post<T, B = unknown>(
        url: string,
        payload?: B,
        config?: AxiosRequestConfig,
        client: AxiosInstance = getAxiosClient(),
    ): Promise<ApiResponse<T>> {
        return makeApiRequest<T>(client.post(url, payload, config));
    }

    public static put<T, B = unknown>(
        url: string,
        payload?: B,
        config?: AxiosRequestConfig,
        client: AxiosInstance = getAxiosClient(),
    ): Promise<ApiResponse<T>> {
        return makeApiRequest<T>(client.put(url, payload, config));
    }

    public static patch<T, B = unknown>(
        url: string,
        payload?: B,
        config?: AxiosRequestConfig,
        client: AxiosInstance = getAxiosClient(),
    ): Promise<ApiResponse<T>> {
        return makeApiRequest<T>(client.patch(url, payload, config));
    }

    public static delete<T>(
        url: string,
        config?: AxiosRequestConfig,
        client: AxiosInstance = getAxiosClient(),
    ): Promise<ApiResponse<T>> {
        return makeApiRequest<T>(client.delete(url, config));
    }
}
